import React from 'react';
import { Grid } from 'react-bootstrap';
import OldBrowserDetector from 'old-browser-detector';

import routes from '../../routes.jsx';
import Header from './Header.jsx';
import Notification from './Notification.jsx';
import notify from '../../lib/notify';

export default class Layout extends React.Component {
  componentDidMount() {
    const Detector = new OldBrowserDetector({ i: 11, c: 60 });
    const browserIsOutdated = Detector.detect();
    const oldBrowserNotificationOptions = {
      type: 'error',
      title: 'Your browser is out of date!',
      messages: ['Use Google Chrome to view this website correctly.'],
      autoDismiss: false,
      action: {
        label: 'Install Google Chrome',
        callback: () => {
          window.location.href = 'https://www.google.com/chrome/browser/';
        },
      },
    };
    if (browserIsOutdated) notify(oldBrowserNotificationOptions);
  }

  render() {
    return (
      <React.Fragment>
        <Header />
        <Grid id="layout-container">
          {routes}
        </Grid>
        <Notification />
      </React.Fragment>
    );
  }
}
